import React from "react";

var status = Object.freeze({
  SETUP: {
    id: 0,
    label: "Erstellung",
    tip: "Das Projekt wird gerade von Ihnen erstellt",
    class: "StatusBadge-Setup"
  },
  WAITING: {
    id: 1,
    label: "Warte auf Kunden",
    tip: "Der Kunde wurde informiert. Es wird auf seine Antwort gewartet",
    class: "StatusBadge-Waiting"
  },
  FINISHED: {
    id: 2,
    label: "Bearbeitet",
    tip:
      "Der Kunde hat auf das Projekt reagiert. Schauen Sie sich seine Antwort an",
    class: "StatusBadge-Accepted"
  },
  CLOSED: {
    id: 3,
    label: "Geschlossen",
    tip: "Das Projekt wurde von Ihnen geschlossen",
    class: ""
  },
  WORKING: {
    id: 4,
    label: (
      <i
        className="fas fa-spinner"
        style={{ animation: "a 2s infinite linear" }}
      />
    ),
    tip: "",
    class: "StatusBadge-Working"
  },
  UNKNOWN: {
    id: 5,
    label: "Unbekannt",
    tip: "Der Status ist nicht bekannt",
    class: ""
  }
});

function getStatusById(id) {
  let s = status.UNKNOWN;
  Object.keys(status).forEach(function(key) {
    if (status[key].id === id) {
      s = status[key];
    }
  });
  return s;
}

function StatusBadge(props) {
  const status = getStatusById(props.status);
  return (
    <div className={`StatusBadge ${status.class}`} title={status.tip}>
      <p>{status.label}</p>
    </div>
  );
}

export default StatusBadge;

/*
old status codes

var status = Object.freeze({
  ACCEPTED: {
    id: 0,
    label: "Warte auf Freigabe",
    class: "StatusBadge-Waiting"
  },
  WAITING: { id: 1, label: "Freigegeben", class: "StatusBadge-Accepted" },
  DENIED: { id: 2, label: "Nicht Freigegeben", class: "StatusBadge-Denied" },
  FINISHED: { id: 3, label: "Abgeschlossen", class: "" },
  UNKNOWN: { id: 4, label: "Unbekannt", class: "" }
});

*/



// WEBPACK FOOTER //
// ./src/components/StatusBadge.js